const TECHNOLOGIES = [
    {
        section: '1',
        id: 1,
        title: 'Hardware and Circuits',
        description: ['Mixed Signal Designs', 'Switching Power Supplies', 
        'Low Noise Analog', 'Low Power Designs', 'Ethernet, SPI, I2C, UART',
        'SERDES, high speed comm.', 'Data Acquisition'],
        cssId: '1'
    },
    {
        section: '2',
        id: 2,
        title: 'Software and Architectures',
        description: ['Unix, freeRTOS, VxWorks, \'Bare Metal\'', 
        'C/C++, Assembly, Python', 'ARM, PowerPC', 
        'MicroBlaze, NIOS', 'AVR, MSP430, HC12', 'Xilinx and Altera FPGAs',
        'Clean, documented software'],
        cssId: '1'
    },
    {
        section: '3',
        id: 3,
        title: 'Industry Experience & Tools',
        description: ['Scientific Instruments', 'Aviation', 
        'Industrial Electronics', 'Oil and Gas', 'Sensors', 
        'Altium, ModelSim, MATLAB'],
        cssId: '1'
    }
]


export default TECHNOLOGIES;
